<template>
  <span>
    <span class="sign">{{formatedPrice.sign}}</span><span class="symbol">&yen; </span><span class="int">{{formatedPrice.int}}</span>.<span class="decimal">{{formatedPrice.decimal}}</span>
  </span>
</template>


<script>
  export default {
    name: 'price',
    props: ['data', 'single', 'bit'],
    data () {
      return {}
    },
    computed: {
      formatedPrice: function () {
        return this.formatPrice(this.data)
      }
    },
    methods: {
      formatPrice (price) {
        const origin = price
        let sign = ''

        if (price < 0) {
          price = Math.abs(price)
          sign = '-'
        }

        const int_number = (price * 100).toFixed(0)
        let decimal = String(int_number % 100)
        let int = String(parseInt(Number(price)))

        // 0.03 -> 3 -> 03
        if (decimal.length === 1) {
          decimal = '0' + decimal
        }

        if (int.length > 3) {
          let remain = 3 - int.length % 3

          switch (remain) {
            case 1:
              int = '0' + int
              break
            case 2:
              int = '00' + int
              break
          }

          let matches = int.match(/.{3}/g)

          if (remain !== 3) {
            matches[0] = matches[0].substring(remain)
          }

          int = matches.join(',')
        }

        return {
          int,
          decimal: this.single === 'false' ? decimal : decimal.substring(0, this.bit || 1),
          origin,
          sign,
          html: `<span class="sign">${sign}</span><span class="symbol">&yen; </span><span class="int">${int}</span><span class="decimal">.${decimal}</span>`
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// index.vue?c76f2de2